export const ATTRIBUTES_OBJECT = {
    company_name: {
        label: "Company Name",
        icon : "domain"
    },
    people_count: {
        label: "People Count",
        icon : "account-group"
    },
    csm: {
        label: "CSM",
        icon : "face-agent"
    },
    sdr: {
        label: "SDR",
        icon : "point-of-sale"
    },
    cid: {
        label: "Internal ID",
        icon : "id-card"
    },
    platform: {
        label: "Product",
        icon : "domain"
    },
    is_p_comp: {
        label: "Is Parent Company",
        icon : "domain"
    },
    p_comp: {
        label: "Parent Company Name",
        icon : "domain"
    },
    status: {
        label: "Status",
        icon : "list-status"
    },
    stage: {
        label: "Stage",
        icon : "map"
    },
    onboarding_won_date: {
        label: "Onboarding won",
        icon : "calendar-range"
    },
    trial_date: {
        label: "Trial / Onboadring ongoing Date",
        icon : "calendar-range"
    },
    mrr: {
        label: "MRR",
        icon : "cash"
    },
    created_at: {
        label: "Created At",
        icon : "calendar-range"
    },
    updated_at: {
        label: "Updated At",
        icon : "calendar-range"
    },
    org_id: {
        label: "Org ID",
        icon : "domain"
    },
    billing_name: {
        label: "Billing Name",
        icon : "form-textbox"
    },
    date: {
        label: "Signed Up At",
        icon : "calendar-range"
    },
    plan: {
        label: "Plan",
        icon : "floor-plan"
    },
    is_churn: {
        label: "Churn Status",
        icon : "exit-run"
    },
    country: {
        label: "Country",
        icon : "earth"
    },
    domain: {
        label: "Domain",
        icon : "office-building"
    },
    conversion_quota: {
        label: "Conversion Quota",
        icon : "counter"
    },
    last_seen: {
        label: "Last Seen",
        icon : "calendar-range"
    },
    billing_frequency: {
        label: "Billing Frequency",
        icon : "counter"
    },
    next_billing_date: {
        label: "Next Billing Date",
        icon : "calendar-range"
    },
    account_type: {
        label: "Account Type",
        icon : "account-box"
    },
    demo_date: {
        label: "Demo Date",
        icon : "calendar-range"
    },
    invoice_raised_date: {
        label: "Onboarding Invoice Raised Date",
        icon : "calendar-range"
    },
    churned_at: {
        label: "Churned At",
        icon : "calendar-range"
    },
    time_taken_to_onboard: {
        label: "Time Taken To Onboard",
        icon : "calendar-range"
    }   
};

export const DATE_KEYS = ["created_at", "updated_at", "date", "last_seen", "demo_date", "invoice_raised_date", "next_billing_date", "churned_at", "onboarding_won_date", "trial_date"];
export const OBJECT_KEYS = ["csm", "sdr", "platform", "p_comp", "plan"];
export const BOOLEAN_KEYS = ["status", "is_churn", "is_p_comp"];